import zenscroll from 'zenscroll';
export default () => {
	const list = document.getElementById("broker-list");

	const handleStateSelect = function(event) {
		const originalEvent = event;
		if( typeof event === 'string' ) {
			event = {
				target: {
					value: event
				}
			}
		}
		const oldState = document.querySelector(".broker-list>li.active");
		if (oldState) {
			oldState.classList.remove("active");
		}
		const oldPath = document.querySelector(`[data-id].active`);
		if (oldPath) {
			oldPath.classList.remove("active");
		}
		const state = document.getElementById(event.target.value);
		// console.log('state', state);
		if (state) {
			state.classList.add("active");
		}
		const mapState = document.querySelector(`[data-id="${event.target.value}"]`);
		if (mapState) {
			mapState.classList.add("active");
		}
		zenscroll.to(list, 500, null, null, true);
		if (typeof dataLayer !== "undefined") {
			// console.log('test', event.target.value, (typeof originalEvent === 'string') ? 'map' : 'dropdown')
			dataLayer.push({
				event: "broker-engagement",
				engagement_target: event.target.value,
				engagement_type: (typeof originalEvent === 'string') ? 'map' : 'dropdown'
			});
		}
	}

	window.addEventListener("DOMContentLoaded", function(event) {
		zenscroll.setup(null, 100)
		const selector = document.getElementById("broker-states");
		if (selector) {
			selector.addEventListener("change", handleStateSelect);
		}
	});

	const mapParts = document.querySelectorAll('[data-id]')
	for( let i = 0; i < mapParts.length; i++ ) {
		mapParts[i].addEventListener('click', function() {
			handleStateSelect( mapParts[i].getAttribute('data-id') )
		})
	}
}